import React, { useState } from 'react'
import PropTypes from 'prop-types'
import Button from '@material-ui/core/Button'
import { gsap } from 'gsap'
import IconArrowRight from '@components/atoms/icons/icon-arrow-right'
import useStyles from './info-card-variant.styles'

const InfoAndImageCardWithOverlay = (props) => {
  const {
    precedingHeading,
    heading,
    cardImage,
    overlayList,
  } = props
  const [isOverlayed, toggleOverlay] = useState(false)
  const list = React.createRef()

  const styles = useStyles({ isOverlayed })

  function showOptions() {
    const newVal = !isOverlayed
    toggleOverlay(newVal)

    if (newVal) {
      gsap.from(list.current, {
        y: 10,
        opacity: 0,
        duration: 0.25,
        delay: 0.175,
      })
    }
  }

  return (
    <div className={`${styles.infoCardWithOverlay} info-card-with-overlay`}>
      <div className={`${styles.copyContainer} info-card-with-overlay--copy-container`}>
        <h3 className={styles.copyHeading}>
          <span className={styles.copyOverline}>{precedingHeading}</span>
          {heading}
        </h3>
        <Button
          className={styles.showOptionsButton}
          onClick={() => showOptions()}
          variant="text"
          color="primary"
          size="small"
          aria-expanded={!!isOverlayed}
        >{ isOverlayed ? 'Hide ' : 'Show '}
          <span className={styles.a11yReader}>&nbsp;{heading}</span>
          &nbsp;Options <span className={styles.arrowRight}><IconArrowRight /></span>
        </Button>
      </div>
      <div className={styles.imgContainer}>
        <div className={styles.imgOverlay}>
          <div aria-hidden={!isOverlayed}>
            <ul className={styles.overlayList} ref={list}>
              {overlayList && overlayList.map((listItem, i) => (
                <li className={styles.overlayListItem} key={`career-tracks-overlay-list-item-${i + 1}`}>{listItem}</li>
              ))}
            </ul>
            <div className={styles.andMoreCopy}>And More!</div>
          </div>
        </div>
        <img className={styles.img} src={cardImage.url} alt="" />
      </div>
    </div>
  )
}

InfoAndImageCardWithOverlay.propTypes = {
  precedingHeading: PropTypes.string,
  heading: PropTypes.string,
  cardImage: PropTypes.object,
  overlayList: PropTypes.array,
}

InfoAndImageCardWithOverlay.defaultProps = {}

export default InfoAndImageCardWithOverlay
